import { useState } from "react";
import { Entrada, Selecao } from "../../components/ui.js";

/** Sentinela impossível de colidir com um valor real do provedor. */
const OUTRO = "__outro__";

/**
 * Lista fechada com escape.
 *
 * A lista cobre o que o provedor aceita hoje; "Outro" existe porque essa lista é
 * uma fotografia, e um valor novo do provedor não pode exigir uma nova versão do
 * sistema para ser usado.
 *
 * Um valor que já está gravado e não está na lista abre direto no campo livre —
 * cair no primeiro item da lista trocaria a configuração sem ninguém pedir.
 */
export function SelecaoComOutro({
  opcoes,
  valor,
  onChange,
  desabilitado,
  rotulo,
}: {
  opcoes: { valor: string; rotulo: string }[];
  valor: string;
  onChange: (valor: string) => void;
  desabilitado?: boolean;
  rotulo: string;
}) {
  const naLista = opcoes.some((o) => o.valor === valor);
  const [livre, setLivre] = useState(!naLista && valor !== "");

  return (
    <div className="flex flex-col gap-2">
      <Selecao
        value={livre ? OUTRO : valor}
        onChange={(e) => {
          if (e.target.value === OUTRO) {
            setLivre(true);
            return;
          }
          setLivre(false);
          onChange(e.target.value);
        }}
        disabled={desabilitado}
        aria-label={rotulo}
      >
        {valor === "" && <option value="">Selecione</option>}
        {opcoes.map((o) => (
          <option key={o.valor} value={o.valor}>
            {o.rotulo}
          </option>
        ))}
        <option value={OUTRO}>Outro…</option>
      </Selecao>

      {livre && (
        <Entrada
          value={valor}
          onChange={(e) => onChange(e.target.value)}
          disabled={desabilitado}
          placeholder="Valor fora da lista"
          autoFocus
        />
      )}
    </div>
  );
}
